import { MILLISECONDS_PER_SECOND } from 'constants/date';
import { DEFAULT_TYPING_ANIMATION_DURATION } from 'components/TypingIndicator/constants';

// 0.1 threshold before 0.5 to tighten tolerance
export const observerOptions = {
  root: null,
  rootMargin: '0px',
  threshold: [
    0.0, 0.02, 0.04, 0.06, 0.08, 0.1, 0.12, 0.14, 0.16, 0.18, 0.2, 0.22, 0.24, 0.26, 0.28, 0.3,
    0.32, 0.34, 0.36, 0.37, 0.38, 0.39, 0.4, 0.41, 0.42, 0.43, 0.44, 0.45, 0.46, 0.47, 0.48, 0.49,
    0.5, 0.52, 0.54, 0.56, 0.58, 0.6, 0.62, 0.64, 0.66, 0.68, 0.7, 0.72, 0.74, 0.76, 0.78, 0.8,
    0.82, 0.84, 0.86, 0.88, 0.9, 0.92, 0.94, 0.96, 0.98, 1.0,
  ],
};

export const TIME_BUFFER_ASYNC_SCROLL_UX = DEFAULT_TYPING_ANIMATION_DURATION + 500;

export const TIME_BUFFER_NEW_MSG_PARSING = 5 * MILLISECONDS_PER_SECOND;

export const TIME_BUFFER_SCROLL_INIT = 2.5 * MILLISECONDS_PER_SECOND;

export const INTERVAL_PING_SCROLL_POSITION = 0.5 * MILLISECONDS_PER_SECOND;

export const PX_TOLERANCE_IS_BOTTOM = 88;

export const RATIO_TOLERANCE_IS_BOTTOM = 0.86;

export const RATIO_SHOW_CTA_LATEST_MSG = 0.5;
